import module from 'contabilidad/clientescuentascontables/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('contabilidad.clientesCuentasContables.cliente.editar', {
    url: '/cliente/{idProveedor}/{clasificacion}/{idAdministrador}/{idCuenta}/{codigoConcepto}/editar',
    data: {
      title: 'Editar',
    },
    resolve: {
      idProveedor: ($stateParams) => $stateParams.idProveedor,
      idAdministrador: ($stateParams) => $stateParams.idAdministrador,
      idCuenta: ($stateParams) => $stateParams.idCuenta,
      clasificacion: ($stateParams) => $stateParams.clasificacion,
      codigoConcepto: ($stateParams) => $stateParams.codigoConcepto,
    },
    views: {
      '@': {
        template: '<contabilidad-clientescuentascontables-detalle-editar id-cliente="idCliente" id-proveedor="idProveedor" ' +
          'id-administrador="idAdministrador" id-cuenta="idCuenta" clasificacion="clasificacion" codigo-concepto="codigoConcepto"/>',
        controller: ($scope, idCliente, idProveedor, idAdministrador, idCuenta, clasificacion, codigoConcepto) => {
          $scope.idCliente = idCliente
          $scope.idProveedor = idProveedor
          $scope.idAdministrador = idAdministrador
          $scope.idCuenta = idCuenta
          $scope.clasificacion = clasificacion
          $scope.codigoConcepto = codigoConcepto
        },
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/routes/contabilidad/clientesCuentasContables/lista/detalle/editar.js